import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { gutil } from '../gutil';
import { ActivatedRoute} from "@angular/router";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import * as AOS from 'aos';

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.scss']
})
export class CareersComponent implements OnInit {

  public faMapMarkerAlt = faMapMarkerAlt;
  public openjobs:Array<any>;
  public openjobsdetails:Array<any>;
  public careers = {firstname:"",lastname:"",email:"",phone:"", job_id:0, section:"" };
  public filename1: File;
  public oj_id:number = 0;
  public oj_designation:string;
  public oj_min_yoe:number=0;
  public oj_max_yoe:number=0;
  public oj_location:string;
  public oj_typeDesc:string;
  public oj_description:string;
  public oj_role:string;
  public oj_qualifications:string;
  public id:number = 1;
  public form_msg:boolean = false;
  public form_submit_msg:string;
  public loader:boolean = true;
  
  constructor(private http: HttpClient, private routeact: ActivatedRoute) { 
    this.id = this.routeact.snapshot.params['id'];
  }

  ngOnInit(): void {
    AOS.init(); 
    this.fetchJobs();
    window.scrollTo(0,0);
  }

  public fetchJobs(){
    this.http.get(gutil.devapiUrl + '/api/w/v1/job/getall')
        .subscribe((data:any) => {
          this.openjobs = data.data;
          this.viewJob(this.openjobs[0].id)        
        },
        err => console.error(err)
        );
      this.viewJob(this.id);
  }

  public viewJob(id:number) {
    for (let key in this.openjobs) {
      if(this.openjobs[key].id == id){
          this.oj_id= this.openjobs[key].id;
          this.oj_designation= this.openjobs[key].designation;
          this.oj_min_yoe= this.openjobs[key].min_yoe;
          this.oj_max_yoe= this.openjobs[key].max_yoe;
          this.oj_location= this.openjobs[key].location;
          this.oj_typeDesc= this.openjobs[key].typeDesc;
          this.oj_description= this.openjobs[key].description;
          this.oj_role= this.openjobs[key].role;
          this.oj_qualifications= this.openjobs[key].qualifications;
          
      }
      this.loader = false;
    }
    this.jobScroll();
  }
  public changeFirstName(value:string) {
    this.careers.firstname = value;
    
  }
  public changeEmail(value:any) {
    this.careers.email = value;
    
  }
  public changePhone(value:any) {
    this.careers.phone = value;
    
  }
  public changeLastName(value:string) {
    this.careers.lastname = value;
    
  }
  public onChangeResumeUpload(value:any){
    let fileList: FileList = value.target.files;
    if(fileList.length > 0) {
        this.filename1 = fileList[0];
        console.log(this.filename1);
    }
    
  }
  public applyForJob(){
      let checkFormVal = this.checkForm();
      let headers = new HttpHeaders({'Accept': 'application/json'});
      let options =  {headers: headers }; 

      let formData:FormData = new FormData();
      formData.append('filename1', this.filename1, this.filename1.name);

      this.careers.job_id = this.oj_id;
      for(let x in this.careers){   
        formData.append(x, this.careers[x]);
      }
      
      this.http.post(gutil.devapiUrl + '/api/w/v1/job/apply',formData, options)
        .subscribe((data:any) => {
            console.log(data);
          },
        );
      this.jobSubmit(); 
    }
    public sendToForm() {
      var sub_form = document.getElementById('submit_form');
      sub_form.scrollIntoView({behavior: 'smooth'});
    }
    public jobScroll() {
      var job_view = document.getElementById('job_view');
      job_view.scrollIntoView({behavior: 'smooth'});
    }
    public checkForm() {
      let rtrn = true;
      if(this.careers.firstname == "" || this.careers.email == "" || this.careers.phone == "") {
        console.log("Please fill all the fields");
        rtrn = false;
        this.form_msg = true;
        this.form_submit_msg = "All Fields Mandatory";
      }
      return rtrn;
    }
    public jobSubmit() {
      this.form_msg = true;
      this.form_submit_msg = "Thank You for your application!";
      window.location.href = "careers", 3000;
    }
}
